module.exports = __webpack_public_path__ + "media/images/line-2@2x-47983b605ff68cd5a8332c67845e217b.png";